import React from 'react'
import Typography from '@ntuctech/devex-tangram/Typography'
import BarcodeSection from '../../../sections/BarcodeSection'
import Benefits from '../../../sections/Benefits'
import MembershipForm from '../../../sections/MembershipForm'
import Panel from '../../../Panel/Panel'
import useExpiryHook from './useExpiryHook'
import { MembershipAlert, RenewButton, RenewWrapper } from './elements'

const MembershipDetails = ({ data, track }) => {
  const {
    expiring,
    expiryDate,
    expiryText,
    hasExpired,
    isRenewing,
    onClickRenewButton,
  } = useExpiryHook({
    data,
  })

  return (
    <>
      {expiring && (
        <MembershipAlert expired={hasExpired}>{expiryText}</MembershipAlert>
      )}
      {hasExpired || isRenewing ? (
        <Panel
          title="Membership renewal"
          data-testid="membership-renewal-panel"
        >
          <MembershipForm
            tncUrl={data && data.tncUrl}
            isRenewingMembership
            packages={data.packages || []}
            userId={data.userId}
            track={track}
          />
        </Panel>
      ) : (
        <Panel
          title={`Welcome back, ${data.userName}!`}
          shadow
          data-testid="loyalty-member-panel"
        >
          {data.membership.cardNumber && (
            <BarcodeSection
              name={data.userName}
              memberType={`${data.title} Member`}
              cardNumber={data.membership.cardNumber}
              date={expiryDate}
            />
          )}
          {expiring && !hasExpired && (
            <RenewWrapper>
              <RenewButton onClick={onClickRenewButton} fullWidth size="l">
                Renew membership
              </RenewButton>
              <Typography>
                Renew your membership now to enjoy your benefits without any
                disruption
              </Typography>
            </RenewWrapper>
          )}
          <Benefits content={data.benefits} isMember />
        </Panel>
      )}
    </>
  )
}

export default MembershipDetails
